import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import React from "react";
import { StyledFeedbackIcon } from "../custom-styles/new-edit-form/NewEditForm.styles";
import Text from "shared/components/data-display/text/Text";

const DateRangevalidationForAllotment = ({
    isPTORequest,
    exceededDaysErrorMessage,
}) => {
    return (
        <HStack spacing="Zero_25" align="flex-start">
            <StyledFeedbackIcon
                size={16}
                name={isPTORequest ? "warning" : "error"}
                color={isPTORequest ? "Yellow" : "Orange_1"}
            />
            <Text color="Black" variant="Body_2_2">
                {exceededDaysErrorMessage}
            </Text>
        </HStack>
    );
};

DateRangevalidationForAllotment.propTypes = {
    isPTORequest: PropTypes.bool,
    exceededDaysErrorMessage: PropTypes.string.isRequired
};

export default DateRangevalidationForAllotment;
